<template>
  <section v-if="status !== 'loading' && steps.length" class="buy-guide">
    <header class="buy-guide__header">
      <step-navigation v-if="!showResult">
      </step-navigation>
      <h1 class="buy-guide__title" v-html="!showResult ? steps[currentStepIndex].Header : result.Header"></h1>
      <div class="buy-guide__preamble" v-html="!showResult ? steps[currentStepIndex].Preamble : result.Preamble"></div>
    </header>
    <div class="buy-guide__content" v-if="!showResult">
      <component
        v-if="steps[currentStepIndex].Type === steps[currentStepIndex].Type"
        :is="componentTypeToKebabCase(steps[currentStepIndex].Type)"
        :getNumberOfColumns="getNumberOfColumns"
        :options="steps[currentStepIndex].Options"
        :sections="steps[currentStepIndex].Sections"
        :type="steps[currentStepIndex].Type"
      >
      </component>
      <div class="buy-guide__nav" v-if="steps[currentStepIndex].Type !== 'subGoal'">
        <button
          class="button is--yellow is--solid has--icon"
          v-on:click="goToNextStep"
        >
          <span class="text">Nästa</span>
          <span class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17"><path fill="#005997" d="M17.293 8L10.146.854c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l8 8c.195.196.195.512 0 .708l-8 8c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708L17.293 9H.5C.224 9 0 8.776 0 8.5S.224 8 .5 8h16.793z"></path></svg>
          </span>
        </button>
      </div>
    </div>
    <result v-if="showResult"></result>
  </section>
</template>

<script>

import Vue from 'vue';
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
// components
import AreaOfUse from '@/components/buy-guide/steps/area-of-use.vue';
import AutomaticDoor from '@/components/buy-guide/steps/automatic-door.vue';
import ColorsMaterials from '@/components/buy-guide/steps/colors-materials.vue';
import GarageType from '@/components/buy-guide/steps/garage-type.vue';
import HouseStyle from '@/components/buy-guide/steps/house-style.vue';
import HouseType from '@/components/buy-guide/steps/house-type.vue';
import Montage from '@/components/buy-guide/steps/montage.vue';
import Result from '@/components/buy-guide/steps/result.vue';
import StepNavigation from '@/components/buy-guide/components/step-navigation/step-navigation.vue';
import SubGoal from '@/components/buy-guide/steps/sub-goal.vue';

import {
  getNumberOfColumns,
  toKebabCase
} from '@/components/buy-guide/utils/utils.js'

import { validateChoice } from '@/components/buy-guide/validate/index';
//
@Component({
    props: {
      'endpoint': String
    },
    computed: {
      ...mapState({
        currentStepIndex: state => state.buyGuide.currentStepIndex,
        currentChoice: state => state.buyGuide.currentChoice,
        showResult: state => state.buyGuide.showResult,
        steps: state => state.buyGuide.steps,
        status: state => state.buyGuide.status,
        result: state => state.buyGuide.result
      }),
      ...mapGetters('buyGuide', {
          getCurrentStep: 'getCurrentStep'
      }),
      currentStep () {
        return this.getCurrentStep(this.currentStepIndex)
      }
    },
    watch: {
      currentChoice: function (newChoice, oldChoice) {
        const validate = this.validateChoice({
          step: this.currentStep,
          choice: newChoice
        })
        this.toggleStepIsComplete(validate.isValid);
        // console.log('currentChoice validate', validate)
      }
    },
    components: {
      'area-of-use': AreaOfUse,
      'automatic-door': AutomaticDoor,
      'colors-materials': ColorsMaterials,
      'garage-type': GarageType,
      'house-style': HouseStyle,
      'house-type': HouseType,
      'montage': Montage,
      'result': Result,
      'step-navigation': StepNavigation,
      'sub-goal': SubGoal,
    },
    methods: {
      ...mapActions('buyGuide', ['getBuyGuide']),
      ...mapMutations([
        'buyGuide/setCurrentStepIndex',
        'buyGuide/toggleShowResult',
        'buyGuide/incrementStepIndex',
        'buyGuide/toggleStepIsComplete'
      ]),
      getNumberOfColumns
    }
})
export default class BuyGuide extends Vue {
  @Prop() endpoint;

  created() {
    // console.log('BuyGuide created');
  }

  mounted() {
    !!this.endpoint && this.$store.dispatch(
      'buyGuide/getBuyGuide', {
        api: this.endpoint,
        params: null,
        callback: this.setCurrentStepType
      }
    )
  }

  goToNextStep() {
    if (this.currentStepIndex < (this.steps.length -1)) {
      if (this.steps[this.currentStepIndex].IsComplete === true || this.currentStepIndex === 5) {
        this.$store.commit(
          'buyGuide/incrementStepIndex'
        )
      }
    }
    if (this.currentStepIndex === (this.steps.length -1)) {
      if (this.steps[this.currentStepIndex].IsComplete === true) {
        this.$store.commit(
          'buyGuide/toggleShowResult', {
            showResult: true
        })
      }
    }
  }

  toggleStepIsComplete(isComplete) {
    this.$store.commit(
      'buyGuide/toggleStepIsComplete', {
        stepIndex: this.currentStepIndex,
        isComplete
      })
  }

  validateChoice({step, choice}) {
    return validateChoice({step, choice});
  }

  componentTypeToKebabCase(str) {
    return toKebabCase(str);
  }

}
</script>

<style>

</style>

